var _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path3, _path4, _path5, _g9, _path6, _path7, _path8, _g10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVerbalAndNonVerbal = function SvgVerbalAndNonVerbal(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 217,
    viewBox: "0 0 217 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 427318770"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Right",
    d: "M186.335 173.223L171.582 164.707C171.209 164.494 171.209 163.801 171.582 163.161L182.95 143.477C183.323 142.837 183.923 142.491 184.296 142.704L199.049 151.22C199.595 151.54 199.302 152.793 198.543 153.379L190.12 159.829C189.72 160.136 189.4 160.682 189.347 161.176L187.974 171.704C187.854 172.65 186.908 173.543 186.362 173.223H186.335Z",
    fill: "#4539FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Left",
    d: "M31.0479 173.223L45.801 164.707C46.1742 164.494 46.1742 163.801 45.801 163.148L34.3797 143.357C34.0066 142.718 33.4068 142.371 33.0337 142.584L18.2806 151.1C17.7342 151.42 18.0274 152.673 18.8004 153.259L27.2497 159.763C27.6495 160.069 27.9694 160.616 28.036 161.122L29.4354 171.691C29.5686 172.65 30.5015 173.53 31.0479 173.223Z",
    fill: "#4539FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Back",
    filter: "url(#filter0_d_1241_128212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.865 108.36C192.865 154.872 155.163 192.561 108.665 192.561C62.1666 192.561 24.4644 154.858 24.4644 108.36C24.4644 61.8622 62.1666 24.1599 108.665 24.1599C123.098 24.1599 136.692 27.7982 148.566 34.1952C174.94 48.4152 192.865 76.2954 192.865 108.36Z",
    fill: "url(#paint0_linear_1241_128212)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Front"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M188.174 108.36C188.174 152.273 152.577 187.883 108.651 187.883C64.7254 187.883 29.1288 152.286 29.1288 108.36C29.1288 64.4343 64.7254 28.8377 108.651 28.8377C122.285 28.8377 135.119 32.2628 146.327 38.3133C171.235 51.7469 188.161 78.0679 188.161 108.347L188.174 108.36Z",
    fill: "url(#paint1_linear_1241_128212)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Base"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1241_128212",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 28,
    width: 160,
    height: 160
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Front-2",
    d: "M188.174 108.36C188.174 152.273 152.577 187.883 108.651 187.883C64.7254 187.883 29.1288 152.286 29.1288 108.36C29.1288 64.4343 64.7254 28.8377 108.651 28.8377C122.285 28.8377 135.119 32.2628 146.327 38.3133C171.235 51.7469 188.161 78.0679 188.161 108.347L188.174 108.36Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1241_128212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M110.904 239.299C165.672 239.299 210.07 213.063 210.07 180.7C210.07 148.336 165.672 122.101 110.904 122.101C56.1354 122.101 11.7369 148.336 11.7369 180.7C11.7369 213.063 56.1354 239.299 110.904 239.299Z",
    fill: "#00BC6C"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Shine"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1241_128212",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 24,
    width: 169,
    height: 169
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Back-2",
    d: "M192.865 108.36C192.865 154.872 155.163 192.561 108.665 192.561C62.1666 192.561 24.4644 154.858 24.4644 108.36C24.4644 61.8622 62.1666 24.1599 108.665 24.1599C123.098 24.1599 136.692 27.7982 148.566 34.1952C174.94 48.4152 192.865 76.2954 192.865 108.36Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1241_128212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.15,
    d: "M6.71272 239.779C4.11394 232.529 2.80789 228.437 0.209106 219.295C17.6276 206.368 36.3388 197.625 54.8634 186.617C74.4542 174.982 90.3534 159.776 107.652 145.076C143.462 114.677 169.823 109.32 215.108 121.488C217.707 123.82 219.013 125.019 221.612 127.618C175.447 113.984 149.406 124.806 114.156 155.791C79.8384 185.977 39.0309 207.914 6.69939 239.765L6.71272 239.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.15,
    d: "M-3.29589 223.613C-19.1151 195.546 -26.1651 162.468 -33.5483 131.509C13.8161 132.269 39.1108 108.52 73.9078 79.4939C109.424 49.8679 137.105 42.0182 181.364 56.7046C191.839 67.1131 201.888 77.3483 211.616 88.463C165.585 66.6066 135.586 96.5259 104.16 128.657C70.1629 163.428 32.0608 190.762 -3.29589 223.613Z",
    fill: "white"
  })))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Stars",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M128.309 37.2605C128.92 37.2605 129.415 36.7652 129.415 36.1543C129.415 35.5434 128.92 35.0482 128.309 35.0482C127.698 35.0482 127.203 35.5434 127.203 36.1543C127.203 36.7652 127.698 37.2605 128.309 37.2605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M133.693 48.6417C135.04 48.6417 136.132 47.5498 136.132 46.2029C136.132 44.8559 135.04 43.764 133.693 43.764C132.346 43.764 131.254 44.8559 131.254 46.2029C131.254 47.5498 132.346 48.6417 133.693 48.6417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M122.285 43.924C123.198 43.924 123.938 43.1841 123.938 42.2715C123.938 41.3588 123.198 40.6189 122.285 40.6189C121.372 40.6189 120.632 41.3588 120.632 42.2715C120.632 43.1841 121.372 43.924 122.285 43.924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M109.265 173.676C110.56 173.676 111.61 172.626 111.61 171.331C111.61 170.035 110.56 168.985 109.265 168.985C107.969 168.985 106.919 170.035 106.919 171.331C106.919 172.626 107.969 173.676 109.265 173.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M101.948 180.486C103.295 180.486 104.387 179.395 104.387 178.048C104.387 176.701 103.295 175.609 101.948 175.609C100.601 175.609 99.509 176.701 99.509 178.048C99.509 179.395 100.601 180.486 101.948 180.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M91.926 173.143C92.5369 173.143 93.0321 172.648 93.0321 172.037C93.0321 171.426 92.5369 170.931 91.926 170.931C91.3151 170.931 90.8198 171.426 90.8198 172.037C90.8198 172.648 91.3151 173.143 91.926 173.143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M157.215 137.52L155.216 140.798C154.91 141.305 154.163 141.305 153.843 140.798L151.844 137.52C151.685 137.267 151.685 136.947 151.844 136.68L153.843 133.402C154.15 132.895 154.896 132.895 155.216 133.402L157.215 136.68C157.375 136.934 157.375 137.267 157.215 137.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M164.438 135.628L163.626 136.947C163.506 137.16 163.199 137.16 163.066 136.947L162.253 135.628C162.186 135.521 162.186 135.388 162.253 135.294L163.066 133.975C163.186 133.762 163.492 133.762 163.626 133.975L164.438 135.294C164.505 135.401 164.505 135.534 164.438 135.628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M58.0219 63.6214L56.7025 65.767C56.5159 66.0602 56.0895 66.0602 55.9029 65.767L54.7434 63.8613C54.6501 63.7147 54.6501 63.5281 54.7434 63.3682L55.9029 61.4624C56.0895 61.1692 56.5159 61.1692 56.7025 61.4624L58.0219 63.608V63.6214Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M65.8449 57.1044L63.5793 60.8094C63.2195 61.3824 62.3799 61.3824 62.0334 60.8094L59.7678 57.1044C59.5945 56.8112 59.5945 56.4514 59.7678 56.1582L62.0334 52.4533C62.3932 51.8802 63.2328 51.8802 63.5793 52.4533L65.8449 56.1582C66.0182 56.4514 66.0182 56.8112 65.8449 57.1044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M162.133 126.885L160.56 129.457C160.321 129.857 159.734 129.857 159.481 129.457L157.908 126.885C157.788 126.685 157.788 126.432 157.908 126.232L159.481 123.66C159.721 123.26 160.307 123.26 160.56 123.66L162.133 126.232C162.253 126.432 162.253 126.685 162.133 126.885Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Vector_16",
    filter: "url(#filter1_d_1241_128212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.163 104.536L151.285 104.056L150.432 109.293C150.205 110.706 148.379 111.119 147.553 109.946L142.369 102.576L106.159 96.5793C102.921 96.0462 100.722 92.981 101.255 89.7292L106.359 58.9036C106.892 55.6652 109.958 53.4662 113.209 53.9993L161.213 61.9555C164.452 62.4886 166.651 65.5538 166.118 68.8056L161.014 99.6312C160.48 102.87 157.415 105.069 154.163 104.536Z",
    fill: "url(#paint2_linear_1241_128212)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.163 104.536L151.285 104.056L150.432 109.293C150.205 110.706 148.379 111.119 147.553 109.946L142.369 102.576L106.159 96.5793C102.921 96.0462 100.722 92.981 101.255 89.7292L106.359 58.9036C106.892 55.6652 109.958 53.4662 113.209 53.9993L161.213 61.9555C164.452 62.4886 166.651 65.5538 166.118 68.8056L161.014 99.6312C160.48 102.87 157.415 105.069 154.163 104.536Z",
    stroke: "#FDB35E",
    strokeWidth: 1.6259,
    strokeMiterlimit: 10
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M121.392 80.68C123.181 80.68 124.631 79.2301 124.631 77.4415C124.631 75.653 123.181 74.2031 121.392 74.2031C119.603 74.2031 118.154 75.653 118.154 77.4415C118.154 79.2301 119.603 80.68 121.392 80.68Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M134.946 82.9323C136.734 82.9323 138.184 81.4824 138.184 79.6939C138.184 77.9053 136.734 76.4554 134.946 76.4554C133.157 76.4554 131.707 77.9053 131.707 79.6939C131.707 81.4824 133.157 82.9323 134.946 82.9323Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M148.499 85.1846C150.288 85.1846 151.738 83.7347 151.738 81.9461C151.738 80.1576 150.288 78.7076 148.499 78.7076C146.711 78.7076 145.261 80.1576 145.261 81.9461C145.261 83.7347 146.711 85.1846 148.499 85.1846Z",
    fill: "white"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Vector_20",
    filter: "url(#filter2_d_1241_128212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.327 129.51L64.7121 129.231L65.2185 135.401C65.3518 137.067 67.4308 137.72 68.497 136.44L75.2138 128.364L117.887 124.819C121.712 124.499 124.551 121.141 124.231 117.329L121.219 80.9999C120.899 77.175 117.541 74.3363 113.729 74.6562L57.1556 79.3473C53.3307 79.6672 50.4921 83.0256 50.8119 86.8371L53.8239 123.167C54.1437 126.992 57.5021 129.83 61.3137 129.51H61.327Z",
    fill: "url(#paint3_linear_1241_128212)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.327 129.51L64.7121 129.231L65.2185 135.401C65.3518 137.067 67.4308 137.72 68.497 136.44L75.2138 128.364L117.887 124.819C121.712 124.499 124.551 121.141 124.231 117.329L121.219 80.9999C120.899 77.175 117.541 74.3363 113.729 74.6562L57.1556 79.3473C53.3307 79.6672 50.4921 83.0256 50.8119 86.8371L53.8239 123.167C54.1437 126.992 57.5021 129.83 61.3137 129.51H61.327Z",
    stroke: "#7B60F9",
    strokeWidth: 1.6259,
    strokeMiterlimit: 10
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M65.9781 103.856L107.798 100.377",
    stroke: "#F1EEFD",
    strokeWidth: 3.07855,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M65.0985 93.3408L106.919 89.8757",
    stroke: "#F1EEFD",
    strokeWidth: 3.07855,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M66.8444 114.358L108.665 110.879",
    stroke: "#F1EEFD",
    strokeWidth: 3.07855,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Banner"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M169.45 175.929C128.082 161.802 89.5671 161.642 48.0266 175.475C45.7343 176.368 43.2822 175.689 42.5358 173.89C38.1512 166.813 35.899 163.308 31.2345 156.378C30.4482 154.605 31.9541 152.206 34.6062 151.127C85.1691 133.055 132.52 133.215 182.977 151.633C185.629 152.74 187.121 155.138 186.322 156.911C181.644 163.814 179.365 167.306 174.967 174.369C174.207 176.155 171.742 176.808 169.463 175.902L169.45 175.929Z",
    fill: "#4539FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M50.0657 157.324L50.1456 164.774L48.1333 165.507L43.3755 159.776L45.0814 159.15L48.5331 163.521L48.3465 157.95L50.039 157.324H50.0657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M53.7306 157.604L54.157 158.963L56.3427 158.27L56.7425 159.523L54.5569 160.216L55.0233 161.682L57.4888 160.909L57.9019 162.215L53.7972 163.508L51.6915 156.818L55.7963 155.525L56.2094 156.831L53.7439 157.604H53.7306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M63.0062 160.789L60.9005 158.617L60.5007 158.723L61.1937 161.282L59.5412 161.735L57.702 154.965L60.4741 154.219C61.0071 154.072 61.4869 154.046 61.9134 154.126C62.3398 154.206 62.6863 154.392 62.9662 154.659C63.2461 154.938 63.4327 155.272 63.5393 155.671C63.6592 156.125 63.6459 156.564 63.486 156.978C63.326 157.404 63.0195 157.75 62.5664 158.03L64.8587 160.283L62.9929 160.789H63.0062ZM60.1942 157.551L61.2204 157.271C61.5269 157.191 61.7268 157.057 61.8334 156.858C61.94 156.671 61.9667 156.444 61.8867 156.165C61.8201 155.911 61.6868 155.725 61.5002 155.618C61.3137 155.512 61.0604 155.498 60.7539 155.578L59.7277 155.858L60.1809 157.537L60.1942 157.551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M70.9225 155.791C71.229 156.045 71.4289 156.364 71.5222 156.764C71.6555 157.337 71.5622 157.83 71.229 158.257C70.9092 158.683 70.3894 158.977 69.6697 159.136L66.4846 159.869L64.9253 153.033L68.0038 152.326C68.6969 152.166 69.2832 152.206 69.7497 152.433C70.2161 152.659 70.5093 153.046 70.6293 153.592C70.7226 153.992 70.6959 154.352 70.536 154.672C70.3894 154.992 70.1495 155.232 69.8163 155.418C70.2295 155.418 70.5893 155.538 70.9091 155.791H70.9225ZM67.2309 155.418L68.3237 155.165C68.6036 155.098 68.7901 154.992 68.9101 154.845C69.03 154.685 69.0567 154.499 69.0034 154.259C68.9501 154.019 68.8301 153.859 68.6569 153.779C68.4836 153.699 68.2571 153.672 67.9905 153.739L66.8977 153.992L67.2309 155.418ZM69.6831 157.524C69.803 157.364 69.843 157.164 69.7897 156.924C69.7364 156.684 69.6164 156.511 69.4165 156.418C69.2299 156.311 68.9901 156.298 68.7102 156.364L67.4974 156.644L67.8439 158.15L69.07 157.87C69.3499 157.804 69.5498 157.697 69.6697 157.537L69.6831 157.524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M77.6526 156.284L75.0805 156.764L74.8939 158.057L73.1348 158.377L74.3609 151.02L76.3066 150.66L80.0782 157.097L78.3057 157.431L77.666 156.284H77.6526ZM76.9863 155.072L75.6669 152.7L75.2804 155.378L76.9863 155.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M82.9702 155.352L85.1825 155.032L85.3691 156.338L81.4643 156.911L80.4514 149.967L82.1439 149.714L82.9702 155.352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M94.9779 155.312L94.2716 154.739C93.6719 155.285 92.9255 155.605 92.0326 155.685C91.4995 155.738 91.0198 155.685 90.6066 155.551C90.1935 155.418 89.8603 155.192 89.6204 154.885C89.3805 154.579 89.2339 154.219 89.194 153.779C89.154 153.339 89.2339 152.939 89.4338 152.553C89.6337 152.18 89.9669 151.86 90.42 151.58C90.2335 151.38 90.0869 151.194 89.9936 151.007C89.9003 150.82 89.847 150.607 89.8203 150.381C89.7937 150.047 89.847 149.741 89.9936 149.448C90.1402 149.154 90.3667 148.928 90.6866 148.741C91.0064 148.555 91.3796 148.448 91.8327 148.395C92.2858 148.355 92.6857 148.395 93.0188 148.541C93.352 148.675 93.6052 148.875 93.7918 149.141C93.9784 149.408 94.0717 149.701 94.0983 150.034L92.4991 150.181C92.4991 150.007 92.4324 149.874 92.3258 149.781C92.2192 149.688 92.0859 149.661 91.926 149.674C91.7661 149.688 91.6328 149.741 91.5395 149.848C91.4462 149.954 91.4062 150.074 91.4196 150.221C91.4196 150.354 91.4862 150.501 91.5928 150.647C91.6994 150.794 91.8594 150.954 92.0593 151.14L93.9117 152.646C93.9117 152.646 93.9384 152.566 93.9517 152.526C93.965 152.473 93.9917 152.42 94.005 152.366L94.3116 151.7L96.0174 151.54L95.6176 152.446C95.471 152.859 95.2978 153.246 95.0978 153.619L96.9237 155.125L94.9379 155.298L94.9779 155.312ZM93.1388 153.819L91.4462 152.46C90.9931 152.753 90.7799 153.099 90.8199 153.526C90.8465 153.779 90.9665 153.979 91.1664 154.125C91.3663 154.272 91.6461 154.339 91.9793 154.312C92.4191 154.272 92.8056 154.112 93.1254 153.832L93.1388 153.819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M107.332 154.739L105.626 154.792L102.654 150.541L102.774 154.872L101.068 154.925L100.868 147.915L102.574 147.862L105.546 152.126L105.426 147.782L107.132 147.729L107.332 154.739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M110.73 154.365C110.184 154.046 109.758 153.606 109.451 153.059C109.145 152.513 108.985 151.887 108.998 151.194C108.998 150.501 109.185 149.888 109.518 149.354C109.851 148.821 110.291 148.395 110.85 148.102C111.41 147.808 112.01 147.662 112.676 147.675C113.343 147.675 113.942 147.848 114.475 148.168C115.022 148.488 115.448 148.915 115.755 149.474C116.061 150.034 116.208 150.647 116.195 151.327C116.181 152.02 116.008 152.633 115.675 153.166C115.342 153.712 114.902 154.126 114.355 154.419C113.809 154.712 113.196 154.859 112.543 154.845C111.89 154.845 111.277 154.672 110.744 154.352L110.73 154.365ZM113.916 152.766C114.262 152.406 114.435 151.913 114.449 151.3C114.449 150.687 114.302 150.181 113.969 149.808C113.636 149.434 113.196 149.234 112.636 149.221C112.063 149.221 111.61 149.381 111.277 149.741C110.944 150.101 110.757 150.594 110.744 151.22C110.744 151.833 110.89 152.34 111.224 152.713C111.557 153.086 111.997 153.286 112.57 153.299C113.129 153.299 113.582 153.126 113.929 152.766H113.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M123.951 155.365L122.245 155.245L119.686 150.74L119.393 155.058L117.687 154.938L118.154 147.942L119.859 148.062L122.418 152.593L122.711 148.248L124.417 148.368L123.951 155.365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M130.588 151.82L130.428 153.233L126.057 152.753L126.217 151.34L130.588 151.82Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M139.837 150.341L136.318 156.898L134.199 156.578L132.8 149.261L134.599 149.541L135.519 155.045L138.051 150.074L139.837 150.354V150.341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M142.889 152.326L142.622 153.712L144.874 154.152L144.621 155.445L142.369 155.005L142.076 156.511L144.621 157.004L144.355 158.35L140.13 157.524L141.476 150.634L145.701 151.46L145.434 152.806L142.889 152.313V152.326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M149.539 159.55L148.726 156.631L148.326 156.538L147.713 159.11L146.047 158.71L147.66 151.887L150.445 152.553C150.978 152.686 151.418 152.886 151.751 153.166C152.084 153.446 152.311 153.766 152.418 154.139C152.524 154.512 152.538 154.899 152.444 155.298C152.338 155.751 152.111 156.125 151.778 156.418C151.445 156.711 151.005 156.871 150.459 156.911L151.391 159.989L149.512 159.55H149.539ZM148.606 155.365L149.632 155.605C149.939 155.671 150.179 155.658 150.365 155.538C150.552 155.432 150.685 155.232 150.738 154.965C150.805 154.712 150.778 154.485 150.658 154.299C150.538 154.112 150.325 153.979 150.032 153.912L149.006 153.672L148.606 155.365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M158.854 158.95C159.001 159.323 159.028 159.696 158.921 160.096C158.761 160.656 158.441 161.056 157.948 161.269C157.455 161.482 156.869 161.495 156.162 161.295L153.017 160.403L154.923 153.646L157.962 154.499C158.641 154.699 159.134 155.005 159.441 155.418C159.747 155.831 159.814 156.324 159.667 156.858C159.561 157.257 159.361 157.551 159.081 157.764C158.801 157.964 158.468 158.07 158.095 158.084C158.468 158.284 158.721 158.563 158.868 158.937L158.854 158.95ZM156.935 159.883C157.122 159.803 157.242 159.643 157.309 159.403C157.375 159.163 157.348 158.963 157.229 158.777C157.109 158.603 156.909 158.47 156.642 158.39L155.443 158.057L155.016 159.55L156.229 159.896C156.509 159.976 156.735 159.976 156.922 159.896L156.935 159.883ZM155.789 156.858L156.869 157.164C157.135 157.244 157.362 157.244 157.535 157.164C157.708 157.084 157.828 156.938 157.895 156.698C157.962 156.458 157.935 156.271 157.828 156.111C157.722 155.951 157.522 155.831 157.255 155.751L156.176 155.445L155.776 156.858H155.789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M164.492 162.615L162 161.789L161.213 162.828L159.521 162.268L164.132 156.404L166.011 157.031L166.211 164.494L164.492 163.921V162.615ZM164.492 161.229V158.51L162.853 160.682L164.492 161.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M169.609 164.361L171.702 165.147L171.235 166.386L167.544 165L170.009 158.43L171.608 159.03L169.609 164.361Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1241_128212",
    x: 0.475628,
    y: 0.171185,
    width: 216.378,
    height: 216.378,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.9944
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_128212"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_128212",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1241_128212",
    x: 100.362,
    y: 53.1066,
    width: 67.8211,
    height: 59.5088,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.17278,
    dy: 1.17278
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_128212"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_128212",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1241_128212",
    x: 49.9744,
    y: 73.8186,
    width: 76.4667,
    height: 65.4816,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.37269,
    dy: 1.37269
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_128212"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_128212",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1241_128212",
    x1: 108.665,
    y1: 227.198,
    x2: 108.665,
    y2: 58.7836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#13D5D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2AD3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#38D394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#3ED38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#40D380"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42D37C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1241_128212",
    x1: 108.665,
    y1: 3.78282,
    x2: 108.665,
    y2: 162.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#08D5E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1DD4BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#2DD3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#38D38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#3FD380"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42D37C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1241_128212",
    x1: 143.951,
    y1: 17.391,
    x2: 132.466,
    y2: 86.6927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F76497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB35E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1241_128212",
    x1: 81.7635,
    y1: 32.5136,
    x2: 88.5363,
    y2: 114.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#61D4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B60F9"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVerbalAndNonVerbal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "verbal-and-non-verbal.9cb3d83.svg";